export default __webpack_public_path__ + "static/media/torre_parque_cafe.db8301f2.jpeg";